import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import CloseIcon from 'assets/icons/CloseIcon';
import MessageIcon from 'assets/icons/MessageIcon';
import { useChatConntext } from 'components/Hoc/MessageProvider';
import CurrentGiveAwayModal from 'features/home/components/Modals/CurrentGiveAwayModal';
import React, { useState } from 'react';
import { setShowChatDesktop, setShowChatMobile } from 'redux/chatSlice';
import { platformStates } from 'redux/platformSlice';
import { isLaptop, isPhone, isTablet } from 'utils/commonUtils';

interface CButtonChatRoomProps {}

const ButtonChatRoom: React.FunctionComponent<CButtonChatRoomProps> = () => {
  const dispatch = useAppDispatch();

  const platform = useAppSelector(platformStates);
  const t = useAppTranslation();

  const [showChat, setShowChat] = useState<boolean>(false);
  const { unreadChatNumber, resetUnread } = useChatConntext();
  const [isShowGiveawayModal, setIsShowGiveawayModal] = useState<boolean>(false);

  const onShowChat = () => {
    if (isPhone(platform) || isTablet(platform) || isLaptop(platform)) {
      dispatch(setShowChatMobile(true));
    } else {
      setShowChat((prev) => !prev);
      dispatch(setShowChatDesktop(true));
    }
    resetUnread();
  };

  return (
    <>
      <div className="chat-room__btn-container">
        <button className="chat-room__show-btn" onClick={onShowChat}>
          {showChat ? <CloseIcon width="20" height="20" /> : <MessageIcon width={25} height={25} />}
        </button>
        {unreadChatNumber !== 0 && <div className="unread-number">{unreadChatNumber}</div>}

        <CurrentGiveAwayModal
          visible={isShowGiveawayModal}
          closeModal={() => setIsShowGiveawayModal(false)}
        />
      </div>
    </>
  );
};

export default ButtonChatRoom;
